import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';

export interface QuestionCard {
	title: string,
	thumbnail?: string,
	rating?: number,
	date?: string,
	actions?: Array<{
		caption: string,
		key: string,
		classes: string | Array<string>
	}>;
	commentsCount?: number;
	removable?: boolean;
	creator?: string;
	usersCount?: number;
	forwarderName?: string;
	forwarderThumbnail?: string;
}

@Component({
	selector: 'app-question-card',
	templateUrl: './question-card.component.html',
	styleUrls: ['./question-card.component.scss']
})
export class QuestionCardComponent implements OnInit, OnChanges {

	@Input() type: 'horizontal' | 'vertical' | 'minimal' = 'horizontal';
	@Input() data: any;
	@Output() detail: any = new EventEmitter();
	@Output() users = new EventEmitter<boolean>();
	@Output() profile: any = new EventEmitter();
	@Output() remove: any = new EventEmitter();
	@Output() action: any = new EventEmitter();
	@Output() forwarderUser: any = new EventEmitter();

	cardData;

	constructor(
		public locale: LocaleService,
		public gfService: GlobalFunctionService
	) {
	}

	ngOnInit(): void {
	}

	ngOnChanges(changes) {
		if (changes.data && changes.data.currentValue) {
			this.cardData = changes.data.currentValue;
			if (!([null, undefined].includes(changes.data.currentValue.rating))) {
				if (changes.data.currentValue.rating > 5) {
					changes.data.currentValue.rating = 5;
				}
				const range = this.range(0, Number(parseFloat(changes.data.currentValue.rating.toString())));
				range.splice(0, 1);
				for (let i = range.length; i < 5; i++) {
					range.push(0);
				}
				this.cardData.ratingData = range.map(data => {
					return {
						isInt: this.isInt(data),
						isFloat: this.isFloat(data),
						value: data
					};
				});
			}
		}
	}

	private range(start: number, end: number) {
		const foo: number[] = [];
		let endValue: any = end.toString().split('.');
		if (endValue.length) {
			endValue = Number(endValue[0]);
		}
		for (let i = start; i <= end; i++) {
			if (i === endValue) {
				foo.push(end);
			} else {
				foo.push(i);
			}
		}
		return foo;
	}

	isInt(n) {
		return Number(n) === n && n % 1 === 0;
	}

	isFloat(n) {
		return Number(n) === n && n % 1 !== 0;
	}

	close(data) {
		if (navigator.onLine) {
			this.remove.emit(data);
		}
	}

	info(data) {
		if (navigator.onLine) {
			this.detail.emit(data);
		}
	}

	profileInfo(data) {
		if (navigator.onLine) {
			this.profile.emit(data);
		}
	}

	usersInfo() {
		if (navigator.onLine) {
			this.users.emit(true);
		}
	}

	actionInfo(action) {
		if (navigator.onLine) {
			this.action.emit(action);
		}
	}

	forwarderUserInfo(data) {
		if (navigator.onLine) {
			this.forwarderUser.emit(data);
		}
	}

}
